import {
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogClose,
  DialogTitle,
  Typography,
  Button,
  Dialog,
} from '@ui/components';
import { useSubscriptions } from '@pages/subscription/hooks';
import { useTranslation } from 'react-i18next';
import { Vector } from '@ui/components/icons';
import { FC } from 'react';

interface UpgradeModalProps {
  subscriptionCode: string | null;
  onClose: ({ upgrade }: { upgrade: boolean }) => void;
}

export const UpgradeModal: FC<UpgradeModalProps> = ({ subscriptionCode, onClose }) => {
  const { initialData, subscriptions, upgradeSubscription, isUpgradeSubscriptionPending } =
    useSubscriptions({
      upgradeSubscriptionSuccess: () => {
        onClose({ upgrade: true });
      },
    });
  const { t } = useTranslation();

  const selectedSubscription = initialData?.items.find(
    (subscription) => subscription.code === subscriptions?.selectedSubscriptionCode,
  );

  const subscriptionToUpgrade = initialData?.items.find(
    (subscription) => subscription.code === subscriptionCode,
  );

  return (
    <Dialog
      onOpenChange={() => {
        onClose({ upgrade: false });
      }}
      open={!!subscriptionCode}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('SUBSCRIPTIONS.UPGRADE_MODAL.TITLE')}</DialogTitle>
        </DialogHeader>
        <div className="px-4 pt-6 pb-2 space-y-4">
          <Typography variant="labelLargeBook">
            {t('SUBSCRIPTIONS.UPGRADE_MODAL.CURRENT_PLAN')}
          </Typography>
          <Typography variant="amountLarge">{selectedSubscription?.name}</Typography>

          <Vector className="size-4" />

          <Typography variant="labelLargeBook">
            {t('SUBSCRIPTIONS.UPGRADE_MODAL.YOU_CHANGE_TO')}
          </Typography>
          <Typography variant="amountLarge">{subscriptionToUpgrade?.name}</Typography>

          <Typography className="mt-6 text-weak" variant="labelSmallBook">
            {t('SUBSCRIPTIONS.MODAL_DESCRIPTION')}
          </Typography>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="tertiary" size="large" wide>
              {t('SUBSCRIPTIONS.UPGRADE_MODAL.CANCEL')}
            </Button>
          </DialogClose>
          <Button
            onClick={() => upgradeSubscription({ subscriptionCode: subscriptionCode! })}
            isLoading={isUpgradeSubscriptionPending}
            disabled={isUpgradeSubscriptionPending}
            size="large"
            wide
          >
            {t('SUBSCRIPTIONS.UPGRADE_MODAL.CONFIRM')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
